import React from 'react'
import '../../Styles/Footer.css'
import TreLogo384 from '../../Assets/TreLogo384.png'
import { Link } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
function Footer() {
  return (
    <div className='Footer-container'>
        <div className='Footer-left'>
            <img className='Footer-left-logo' src={TreLogo384} alt='trehan logo'/>
        </div>
        <div className='Footer-right'>
            <ul className='Footer-right-tabs'>
                <li><Link className='Footer-right-tab' to="/"><HomeIcon style={{fontSize:'1.1rem',marginRight:'10px'}}/><p>Home</p></Link></li>
                <li><Link className='Footer-right-tab' to="/wargaming"><MilitaryTechIcon style={{fontSize:'1.1rem',marginRight:'10px'}}/><p>Wargaming</p></Link></li>
                <li><Link className='Footer-right-tab' to="/about"><DonutLargeIcon style={{fontSize:'1.1rem',marginRight:'10px'}}/><p>About</p></Link></li>
            </ul>
        </div>
    </div>
  )
}

export default Footer